var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { useStore } from "effector-react";
import { Box, Slider, Typography } from "@material-ui/core";
import { $audioCurrentTime } from "frontend/src/domain/audio";
import { mapSecondsToMmSs } from "frontend/src/lib/format-seconds-to-play-time";
import { audioCurrentTimeChanged } from "frontend/src/features/change-audio-current-time";
export var PlayerTimeRange = function (_a) {
    var track = _a.track;
    var currentTimeInSeconds = useStore($audioCurrentTime);
    var _b = __read(React.useState(false), 2), isChanging = _b[0], setChanging = _b[1];
    var _c = __read(React.useState(0), 2), sliderValue = _c[0], setSliderValue = _c[1];
    var durationInSeconds = (track === null || track === void 0 ? void 0 : track.duration.seconds) || 0;
    var durationFormatted = mapSecondsToMmSs(durationInSeconds);
    var currentTimeFormatted = mapSecondsToMmSs(currentTimeInSeconds);
    var onChange = function (e, value) {
        if (typeof value === "number") {
            setChanging(true);
            setSliderValue(value);
        }
    };
    var onChangeCommitted = function (_, value) {
        if (typeof value === "number") {
            audioCurrentTimeChanged((value / 100) * durationInSeconds);
            setTimeout(function () { return setChanging(false); }, 10);
        }
    };
    React.useEffect(function () {
        if (!isChanging) {
            setSliderValue((currentTimeInSeconds / durationInSeconds) * 100);
        }
    }, [isChanging, currentTimeInSeconds, setSliderValue, durationInSeconds]);
    return (React.createElement(Box, { display: "flex", alignItems: "center", width: "100%" },
        React.createElement(Box, { mr: 3 },
            React.createElement(Typography, { variant: "caption" }, currentTimeFormatted)),
        React.createElement(Slider, { disabled: !track, value: sliderValue, onChange: onChange, onChangeCommitted: onChangeCommitted }),
        React.createElement(Box, { ml: 3 },
            React.createElement(Typography, { variant: "caption" }, durationFormatted))));
};
